module.exports = __webpack_public_path__ + "img/roi_high-profile_community.55c1f5c6.jpg";